import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { Radius } from '../types/Radius';

export function composeStartRadiusClasses(radius: Adaptive<Radius>): string {
    if (typeof radius === 'object') {
        return clsx(
            radius.base && `rounded-s-${radius.base}`,
            radius.sm && `sm:rounded-s-${radius.sm}`,
            radius.md && `md:rounded-s-${radius.md}`,
            radius.lg && `lg:rounded-s-${radius.lg}`,
            radius.xl && `xl:rounded-s-${radius.xl}`,
            radius['2xl'] && `2xl:rounded-s-${radius['2xl']}`
        );
    }

    return `rounded-s-${radius}`;
}
